/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useFormik} from 'formik'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useTranslation} from 'react-i18next'
import {useAppDispatch} from '../../../../redux/hooks'
import {resetPassword} from '../../../../redux/Slice/passwordSlice'
import {showErrorMessage, showSuccessMessage} from '_metronic/helpers/swalHelper'
import {useNavigate, useParams} from 'react-router-dom'

const initialValues = {
  password: '',
  password_confirmation: '',
}

export function ResetPassword() {
  const {t} = useTranslation()
  const {token} = useParams()
  const resetToken = token || ''
  const navigate = useNavigate()
  const resetPasswordSchema = Yup.object().shape({
    password: Yup.string()
      .min(6, t('VALIDATION.MIN_CHARACTER_', {quantity: 6}))
      .max(50, t('VALIDATION.MAX_CHARACTER_', {quantity: 50}))
      .required(t('VALIDATION.REQUIRED_', {name: t('GLOBAL.PASSWORD')})),
    password_confirmation: Yup.string()
      .min(6, t('VALIDATION.MIN_CHARACTER_', {quantity: 6}))
      .max(50, t('VALIDATION.MAX_CHARACTER_', {quantity: 50}))
      .required(t('VALIDATION.REQUIRED_', {name: t('GLOBAL.CONFIRM_PASSWORD')}))
      .oneOf(
        [Yup.ref('password')],
        t('VALIDATION.NO_MATCH_', {name: t('GLOBAL.CONFIRM_PASSWORD')})
      ),
  })
  const [loading, setLoading] = useState(false)
  const dispatch = useAppDispatch()

  const formik = useFormik({
    initialValues,
    validationSchema: resetPasswordSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const formData = new FormData()
        formData.append('password', values.password)
        formData.append('password_confirmation', values.password_confirmation)
        formData.append('token', resetToken)

        dispatch(resetPassword(formData)).then((res: any) => {
          if (res.meta.requestStatus === 'fulfilled') {
            showSuccessMessage(t('MESSAGES.PASSWORD_SUCCESSFULLY_RESET'), () => {
              navigate('/auth')
            })
          } else if (res.meta.requestStatus === 'rejected') {
            showErrorMessage(t('MESSAGES.' + res.payload))
          }

          setLoading(false)
          setSubmitting(false)
        })
      } catch (error: any) {
        if (error.response) {
          setStatus(error.response.data.message)
        } else if (error.request) {
          console.log('request', error.request) // No response received
        } else {
          console.log('Error', error.message) // General error
        }
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  return (
    <div className='container-lg d-lg-flex justify-content-lg-center py-20 px-10'>
      <form
        className='form shadow p-4'
        style={{width: '35%'}}
        onSubmit={formik.handleSubmit}
        noValidate
      >
        {/* begin::Heading */}
        <div className='text-center'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logo/new-logo.jpeg')} className='h-100px' />
          <h1 className='text-dark fw-bolder my-4'>{t('PROFILE.RESET_PASSWORD')}</h1>
        </div>
        {/* begin::Heading */}

        <div className='fv-row mb-3'>
          <label className='col-form-label label fw-bolder required'>{t('GLOBAL.PASSWORD')}</label>
          <input
            type='password'
            placeholder={t('GLOBAL.PASSWORD')}
            {...formik.getFieldProps('password')}
            className={clsx(
              'form-control form-control-sm',
              {
                'is-invalid': formik.touched.password && formik.errors.password,
              },
              {
                'is-valid': formik.touched.password && !formik.errors.password,
              }
            )}
          />
          {formik.touched.password && formik.errors.password && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block fw-bold'>
                <span role='alert' className='text-danger'>
                  {formik.errors.password}
                </span>
              </div>
            </div>
          )}
        </div>

        <div className='fv-row mb-3'>
          <label className='col-form-label label fw-bolder required'>
            {t('GLOBAL.CONFIRM_PASSWORD')}
          </label>
          <input
            type='password'
            placeholder={t('GLOBAL.CONFIRM_PASSWORD')}
            {...formik.getFieldProps('password_confirmation')}
            className={clsx(
              'form-control form-control-sm',
              {
                'is-invalid':
                  formik.touched.password_confirmation && formik.errors.password_confirmation,
              },
              {
                'is-valid':
                  formik.touched.password_confirmation && !formik.errors.password_confirmation,
              }
            )}
          />
          {formik.touched.password_confirmation && formik.errors.password_confirmation && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block fw-bold'>
                <span role='alert' className='text-danger'>
                  {formik.errors.password_confirmation}
                </span>
              </div>
            </div>
          )}
        </div>

        {/* begin::Action */}
        <div className='d-grid py-4'>
          <button
            type='submit'
            id='kt_sign_in_submit'
            className='btn btn-primary fw-bold'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            {!loading && <span className='indicator-label'>{t('PROFILE.RESET_PASSWORD')}</span>}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                {t('GLOBAL.PLEASE_WAIT')}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </form>
    </div>
  )
}
